



































































































import Vue, { PropType } from 'vue';
import WidgetEventListResourceViewModel from '../services/v1/viewModel/resource/WidgetEventListResourceViewModel';

export default Vue.extend({
  name: 'WidgetEventCard',
  props: {
    value: { type: Object as PropType<WidgetEventListResourceViewModel>, default: undefined },
  },
  data: () => ({
    isAppointmentsVisible: false,
  }),
  computed: {
    dateSectionText(): string {
      const startDate = this.$format.localDate(this.value.startDate!);
      const endDate = this.$format.localDate(this.value.endDate!);
      const dateString = `${startDate} - ${endDate}`;

      const configText = dateString;
      const displayText = this.$tAlt(configText, configText);
      return displayText;
    },
    registrationLink(): string {
      return this.$service.api.core.widgetEvents.getEventRegisterUrl(this.value);
    },
    isRegistrationExternalLink(): boolean {
      return !!this.$routerUtils.isUrl(this.registrationLink);
    },
  },
  methods: {
    toggleAppointments() {
      this.isAppointmentsVisible = !this.isAppointmentsVisible;
    },
    gotoRegister() {
      this.$routerUtils.pushRouteOrUrl(this.$service.api.core.widgetEvents.getEventRegisterUrl(this.value));
    },
    gotoDetail() {
      this.$routerUtils.pushRouteOrUrl(this.$service.api.core.widgetEvents.getEventDetailUrl(this.value));
    },
  },
});
